<div class="m-asm-customer-search"
     (click)="detectedClickOnElement($event)"
>
  <v-asm-customer-search-form
    #searchInput
    [inputValue]="selectedCustomerLabel"
    (keyupEvent)="inputUpdateDetected($event)"
    [labelText]="'asm.emulate.username.placeholder'"
    [processing]="searching"
  >
  </v-asm-customer-search-form>

  <div *ngIf="(customersObs | async) as customers"
       class="a-reference-point"
  >
    <v-asm-customers-search-result
      class="m-search-result"
      vTp="result"
      *ngIf="showSearchResult"
      (customerSelectedEvent)="selectCustomerDetected($event)"
      [customers]="customers"
    >
    </v-asm-customers-search-result>
  </div>
</div>
